import { mergedCaterwaulAndHammerUIThemes as theme } from '@/theme/mergedCaterwaulAndHammerUIThemes';
import Button from '@liveauctioneers/caterwaul-components/lib/Button/Button';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import styled from 'styled-components';

//background and border-color are getting overwritten by the button's brandedButtonStyle
//TO-DO: look into what styles could be removed, including some of these !importants.
export const StyledButton = styled(Button)`
    transition: all 0.5s;
    width: 100%;

    &.submitted {
        cursor: default;
    }

    &[disabled] {
        user-select: none;

        &.primary {
            background-color: ${theme.colors.blue300};
            border-color: ${theme.colors.blue300};

            &:hover {
                background: ${theme.colors.blue200};
            }
        }

        &.secondary {
            &.hover {
                background-color: ${theme.colors.white};
                color: ${theme.colors.blue200};
            }
        }

        &.tertiary {
            background: ${theme.colors.red300};
            border: 1px solid ${theme.colors.red300};

            &:hover {
                background: ${theme.colors.red200};
            }
        }
    }

    &.countdown {
        margin-bottom: 0 !important;
    }

    &.winning {
        background-color: ${theme.colors.teal} !important;
        border-color: ${theme.colors.teal} !important;
        cursor: default;
    }

    &.inactive {
        background-color: ${theme.colors.grey200} !important;
        border-color: ${theme.colors.grey100} !important;
    }

    &.primaryVariant {
        font-size: 14px;
    }
    .currency {
        margin: 0 6px;
    }
`;

export const StyledLink = styled(Link)`
    transition: all 0.5s;
    width: 100%;
`;

export const HoverWrapper = styled.div`
    width: 100%;
    display: flex;

    &.countdown {
        margin-bottom: 0 !important;
    }

    @media (max-width: 500px) {
        text-align: center;
    }
`;
